// 비회원용 raw localStorage 키
export const LK_GUEST_LOCAL_GIFT_CARD_USAGE_GUIDE_DISMISSED =
  'LK_LOCAL_GIFT_CARD_USAGE_GUIDE_DISMISS_FOREVER';
export const LK_MY_INFO_CACHE = 'LK_MY_INFO_CACHE';
export const LK_GUEST_TOKEN = 'LK_GUEST_TOKEN';

// 사용자가 의도적으로 설정한 값
export const ULK_PREFERENCE_TIME_FORMAT = 'preferenceTimeFormat';

// 사용자별 안내창 확인 상태
export const ULK_GUIDE_LOCAL_GIFT_CARD_USAGE_DISMISSED =
  'guideLocalGiftCardUsageDismissed';

// 사용자별 마지막 사용값 기억용
export const ULK_LAST_ATT_SHOULD_SEND_NOTIFICATION = 'lastAttShouldSendNotification';
export const ULK_LAST_POST_IS_STUDENT_READABLE = 'lastPostIsStudentReadable';
export const ULK_LAST_SELECTED_MODUDA_CARD_OWNER = 'lastSelectedModudaCardOwner';

// 소식 설정과 시각은 사용자·역할·학원별 접미사를 붙여 저장한다.
export const LSK_STUDENT_NEWS_VIEW_MODE = 'LSK_STUDENT_NEWS_VIEW_MODE';
export const LSK_STUDENT_NEWS_LAST_TAB = 'LSK_STUDENT_NEWS_LAST_TAB';
export const LSK_STUDENT_NEWS_LAST_VISITED_AT = 'LSK_STUDENT_NEWS_LAST_VISITED_AT';
export const LSK_STUDENT_NEWS_LAST_PUBLISHED_AT = 'LSK_STUDENT_NEWS_LAST_PUBLISHED_AT';
